// app/(app)/inventory/units/_layout.tsx
import { useAppTheme } from "@/hooks/useAppTheme";
import { Stack } from "expo-router";

export default function UnitsLayout() {
  const { colors } = useAppTheme();

  return (
    <Stack
      screenOptions={{
        headerStyle: { backgroundColor: colors.background },
        headerTintColor: colors.text,
        headerShadowVisible: false,
        contentStyle: { backgroundColor: colors.background },
      }}
    >
      <Stack.Screen
        name="index"
        options={{ title: "Units", headerShown: false }}
      />
      <Stack.Screen
        name="add"
        options={{ title: "Add Unit", presentation: "modal" }}
      />
      <Stack.Screen name="[id]" options={{ title: "Edit Unit" }} />
    </Stack>
  );
}
